// utils/buildCeilingGridPixPathsFromLines.ts
import type { IPartialSpace } from "@backend/src/shared/schemas/schemas"; // justera om du har annan import
import { IPixPath } from "@multiconsult-group/multiplacer-ui";

export function buildCeilingGridPixPathsFromLines(
  spaces: IPartialSpace[] | undefined | null
): IPixPath[] {
  const result: IPixPath[] = [];
  const items = spaces ?? [];

  for (const space of items) {
    const spaceId = String(space._id ?? space.globalId ?? space.name ?? "space");
    const grids = space.ceilingGrids ?? [];

    for (let gridIndex = 0; gridIndex < grids.length; gridIndex++) {
      const grid = grids[gridIndex];
      const lines = grid.lines ?? [];

      for (let lineIndex = 0; lineIndex < lines.length; lineIndex++) {
        const line = lines[lineIndex];

        result.push({
          id: `${spaceId}-cg-${gridIndex}-line-${lineIndex}`,
          points: line, // line Ã¤r redan number[][]
          strokeColor: "#5c5c5c",
          strokeWidth: "0.6",
        });
      }
    }
  }

  return result;
}

